import P5 from "p5";

import ISketchformer from "./ISketchformer";
import IMesh from "./IMesh";
import ICameraWrapper from "./ICameraWrapper";
import GeometricOperations from "./GeometricOperations";

export default class Sketchformer implements ISketchformer {
    public mesh!: IMesh;
    public cameraWrapper!: ICameraWrapper;
    public renderWireframe: boolean = true;
    public renderFill: boolean = false;
    public renderTriangleCenter: boolean = false;
    private width!: number;
    private height!: number;
    private __p5Instance!: P5;

    constructor(width: number, height: number, mesh: IMesh, cameraWrapper: ICameraWrapper) {
        this.width = width;
        this.height = height;
        this.mesh = mesh;
        this.cameraWrapper = cameraWrapper;
        this.__p5Instance = mesh.p5Instance;
    }

    public loadModel(name: string): void {
        if (name == "2D plane") {
            this.mesh.create2DPlane(Math.min(this.width, this.height)-80)
        }
        else {
            const recommendedSize: number = this.height;
            //console.log("recommendedSize " + recommendedSize);
            this.mesh.loadMesh(name, recommendedSize);
        }
    }

    public refine(): void {
        this.mesh.refine();
    }

    public toggleWireframe(): void {
        this.renderWireframe = !this.renderWireframe;
    }

    public toggleFill(): void {
        this.renderFill = !this.renderFill;
    }

    public toggleTriangleCenter(): void {
        this.renderTriangleCenter = !this.renderTriangleCenter;
    }

    public render(): void {
        //this.__p5Instance.directionalLight(126, 126, -300, 1, 1, 1);
        this.__p5Instance.ambientLight(0, 60, 0);
        this.__p5Instance.shininess(10);
        this.__p5Instance.specularMaterial(30);
        //this.__p5Instance.normalMaterial();
        //this.__p5Instance.lights();
        let dirX = (this.__p5Instance.mouseX - this.__p5Instance.width) / 2;
        let dirY = (this.__p5Instance.mouseY - this.__p5Instance.height) / 2;
        this.__p5Instance.pointLight(0, 250, 0,
            this.cameraWrapper.position.x,
            this.cameraWrapper.position.y, -1000);
        this.renderWireframe ? this.__p5Instance.stroke(255,0,0) : this.__p5Instance.noStroke();
        //  specularMaterial(250);

        //this.renderFill ? this.__p5Instance.ambientMaterial(0,200,0) : this.__p5Instance.noFill();
        this.renderFill ? this.__p5Instance.specularMaterial(0,250,0) : this.__p5Instance.noFill();
        this.__p5Instance.strokeWeight(0.4);

        this.__p5Instance.model(this.mesh.geometry);
        
        /*
        this.__p5Instance.push();
        this.__p5Instance.translate(-this.mesh.geometricCenter.x, -this.mesh.geometricCenter.y, -this.mesh.geometricCenter.z);
        //this.__p5Instance.normalMaterial();
        this.__p5Instance.beginShape(this.__p5Instance.TRIANGLES);
        for (let i = 0; i < this.mesh.numberOfTriangles; ++i) {
            const a: P5.Vector = this.mesh.getGeometry(i*3);
            const normalA: P5.Vector = this.mesh.getVertexNormal(i*3); 
            const b: P5.Vector = this.mesh.getGeometry(i*3+1);
            const normalB: P5.Vector = this.mesh.getVertexNormal(i*3+1);
            const c: P5.Vector = this.mesh.getGeometry(i*3+2);
            const normalC: P5.Vector = this.mesh.getVertexNormal(i*3+2);

            
                this.__p5Instance.normal(normalA.x, normalA.y, normalA.z);
                this.__p5Instance.vertex(a.x, a.y, a.z);
                this.__p5Instance.normal(normalB.x, normalB.y, normalB.z);
                this.__p5Instance.vertex(b.x, b.y, b.z);
                this.__p5Instance.normal(normalC.x, normalC.y, normalC.z);
                this.__p5Instance.vertex(c.x, c.y, c.z);
        }
        this.__p5Instance.endShape();

    this.__p5Instance.pop();

        if (this.renderTriangleCenter) {
            for (let i = 0; i < this.mesh.numberOfTriangles; ++i) {
                const a: P5.Vector = this.mesh.getGeometry(i*3);
                const b: P5.Vector = this.mesh.getGeometry(i*3+1);
                const c: P5.Vector = this.mesh.getGeometry(i*3+2);

                // tricenter
                let triCenter: P5.Vector = a.copy();
                triCenter.add(b);
                triCenter.add(c);
                triCenter.div(3);
                this.__p5Instance.push();
                this.__p5Instance.specularMaterial(0,250,0)
                    this.__p5Instance.translate(-this.mesh.geometricCenter.x, -this.mesh.geometricCenter.y, -this.mesh.geometricCenter.z);
                    this.__p5Instance.translate(triCenter);
                    this.__p5Instance.sphere(1, 10, 10);
                this.__p5Instance.pop();
            }
        }
        */
/*

        for (let i = 0; i < this.mesh.numberOfVertices; ++i) {
            const a: P5.Vector = this.mesh.vertices[i];
            const n1: P5.Vector = this.mesh.normals[i];
            this.__p5Instance.push();
                this.__p5Instance.translate(-this.mesh.geometricCenter.x, -this.mesh.geometricCenter.y, -this.mesh.geometricCenter.z);
                //this.__p5Instance.translate(a.x, a.y, a.z);
                this.__p5Instance.line(a.x, a.y, a.z, a.x+n1.x, a.x+n1.y, a.z+n1.z);
            this.__p5Instance.pop();
        }
*/

    }

    public computeIntersection(): void {
        var coord1 = this.__p5Instance.createVector(this.__p5Instance.mouseX, this.__p5Instance.mouseY, 0);

        this.__p5Instance.push();
            this.__p5Instance.translate(-this.mesh.geometricCenter.x, -this.mesh.geometricCenter.y, -this.mesh.geometricCenter.z);
            this.__p5Instance.sphere(10, 10, 10);
        this.__p5Instance.pop();

        this.__p5Instance.push();
            this.__p5Instance.translate(this.mesh.geometricCenter.x, this.mesh.geometricCenter.y, 0);
            this.__p5Instance.translate(coord1.x, coord1.y, 0);
            this.__p5Instance.sphere(10, 10, 10);
        this.__p5Instance.pop();

        this.__p5Instance.push();
            this.__p5Instance.translate(this.mesh.geometricCenter.x, this.mesh.geometricCenter.y, 0);
            this.__p5Instance.translate(coord1.x, coord1.y, 10);
            this.__p5Instance.sphere(10, 10, 10);
        this.__p5Instance.pop();

        this.__p5Instance.push();
            this.__p5Instance.translate(this.mesh.geometricCenter.x, this.mesh.geometricCenter.y, 0);
            this.__p5Instance.translate(coord1.x, coord1.y, -10);
            this.__p5Instance.sphere(10, 10, 10);
        this.__p5Instance.pop();
    }


	public computeIntersection2(mx: number, my:number): void {
        var coord1 = this.__p5Instance.createVector(mx, my, 0);
        this.__p5Instance.push();
        this.__p5Instance.translate(-coord1.x, coord1.y, 0);
        this.__p5Instance.sphere(10, 10, 10);
        this.__p5Instance.pop();
	}
}
